import { createContext } from "react"
import { msalAuthProvider } from "./msalAuthProvider"
import { IAccountInfo } from "react-aad-msal"

export const context = createContext({
	msalAuthProvider,
	accountInfo: {} as IAccountInfo
})